__turbopack_context__.v({
  "accordion": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordion",
  "accordionContent": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionContent",
  "accordionContentContainer": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionContentContainer",
  "accordionHeader": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionHeader",
  "caret": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__caret",
  "error": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__error",
  "headerContainer": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__headerContainer",
  "subtitle": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__subtitle",
  "title": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__title",
});
